module.exports = __webpack_public_path__ + "img/Differentiation-BRCA_her2st.4750e85a.png";